// dateMapping.ts - Simple utility to extract dates from backend AccountEntry data
// Backend already provides perfect MM/DD/YYYY dates - just use them directly!

import { AccountEntry } from '../../types';

/**
 * Creates a mapping from period strings (e.g., "Jun-24") to the actual backend dates (e.g., "06/30/2024")
 * Simply extracts the existing 'date' field values - no conversion needed!
 * 
 * @param accounts - Array of AccountEntry objects from backend
 * @returns Object mapping period strings to actual MM/DD/YYYY date strings from backend
 */
export function createPeriodToDateMapping(accounts: AccountEntry[]): Record<string, string> {
  const dateMap: Record<string, string> = {};
  
  // Simply map each month to its corresponding date value from the backend
  accounts.forEach(account => {
    if (account.month && account.date && !dateMap[account.month]) {
      // Use the actual date field from backend - it's already in perfect MM/DD/YYYY format!
      dateMap[account.month] = account.date;
    }
  });
  
  return dateMap;
}

/**
 * Gets the actual backend date for a given period
 * @param period - Period string (e.g., "Jun-24")
 * @param accounts - Array of AccountEntry objects from backend
 * @returns The actual date string from backend in MM/DD/YYYY format or period as fallback
 */
export function getDateForPeriod(period: string, accounts: AccountEntry[]): string {
  const dateMap = createPeriodToDateMapping(accounts);
  return dateMap[period] || period;
}